export default __webpack_public_path__ + "static/bunker-pages-2-781e7411863130ba7553129c38c408c1.jpg";